export const constants = {
    apiKey: '1234567890987654321',
};
